import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { checkAndLoginIfInactive } from '../../utils/check';

const GlobalRouteChangeHandler = () => {
  const history = useHistory();
  const isLoggedIn = useSelector((state) => state.loginInfo?.flag ?? false);
  useEffect(() => {
    const handleRouteChange = (location, action) => {
      if (isLoggedIn) {
        (async () => {
          await checkAndLoginIfInactive();
        })();
      }
    };

    // Listen for route changes
    const unlisten = history.listen(handleRouteChange);

    // Cleanup the listener when the component unmounts
    return () => {
      unlisten();
    };
  }, [history, isLoggedIn]);

  return null;
};

export default GlobalRouteChangeHandler;
